"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var history_1 = require("history");
exports.default = (0, history_1.createBrowserHistory)();
